import React from 'react'

import Router from './Router'
import Header from './Header'
import Footer from './Footer'
import Intro from './Intro'


/*
  TODO:
  Gives a high z-index to intro; Call all react.fragment until showIntro become true (but hide them)
  (fadeIn and small effect when elements appear ?)
  Black background by default
*/

/**
  * @class App
  * Parent component for all the site
*/
class App extends React.Component {

  /* Constructor
    * By default, we show showIntro
  */
  constructor(props) {
    super(props);
    this.state = {
      showIntro: true
    }
  }

  /*
    TODO:
    How to replace the setTimeOut and see when intro is finished?
  */
  componentDidMount() {
    let skipIntro = localStorage.getItem("cosmicintro")
    /* If cosmicintro issets in localstorage, we can skip it */
    if (skipIntro) {
      this.setState({ showIntro: false  })
    /* If not, show it during 3.5 seconds */
    } else {
      setTimeout(() => {
        localStorage.setItem("cosmicintro", this.state.showIntro);
        this.setState({ showIntro: false })
      }, 3500)
    }
  }

  render() {
  	//if(this.state.showIntro) {
	    //return <Intro/>
	  //}

    return(
      <React.Fragment>
        <Header/>
          <Router/>
        <Footer/>
      </React.Fragment>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/components/App.jsx